// /**
//  * src/services/settingsService.js
//  */
// import api from "../lib/api";

// const getUsers = async ({ page = 1, search = "" } = {}) => {
//   const params = new URLSearchParams({ page });
//   if (search) params.set("search", search);
//   const response = await api.get(`/admin/users?${params}`);
//   return response.data;
//   // { success, data: [...], pagination: { currentPage, totalPages, totalUsers, showing } }
// };

// const getArchivedUsers = async ({ page = 1, search = "" } = {}) => {
//   const params = new URLSearchParams({ page });
//   if (search) params.set("search", search);
//   const response = await api.get(`/admin/users/archived?${params}`);
//   return response.data;
// };

// const getUserById = async (userId) => {
//   const response = await api.get(`/admin/users/${userId}`);
//   return response.data;
//   // { success, data: full user object }
// };

// const inviteUser = async (userData) => {
//   const response = await api.post("/admin/users", userData);
//   return response.data;
// };

// const toggleUser = async (userId) => {
//   const response = await api.patch(`/admin/users/${userId}/toggle`);
//   return response.data;
//   // { success, data: { _id, isDisabled, status } }
// };

// const restoreUser = async (userId) => {
//   const response = await api.patch(`/admin/users/${userId}/restore`);
//   return response.data;
// };

// const deleteUser = async (userId) => {
//   const response = await api.delete(`/admin/users/${userId}`);
//   return response.data;
// };

// const settingsService = {
//   getUsers,
//   getArchivedUsers,
//   getUserById,
//   inviteUser,
//   toggleUser,
//   restoreUser,
//   deleteUser,
// };

// export default settingsService;
import api from "../lib/api";

const getUsers = async ({ page = 1, search = "", status = "", picker = false } = {}) => {
  const params = new URLSearchParams({ page: String(page) });
  if (search) params.set("search", search);
  if (status) params.set("status", status);
  if (picker) params.set("picker", "true");
  const response = await api.get(`/admin/users?${params}`);
  return response.data;
};

const getArchivedUsers = async ({ page = 1, search = "" } = {}) => {
  const params = new URLSearchParams({ page });
  if (search) params.set("search", search);
  const response = await api.get(`/admin/users/archived?${params}`);
  return response.data;
};

const getUserById = async (userId) => {
  const response = await api.get(`/admin/users/${userId}`);
  return response.data;
};

const inviteUser = async (userData) => {
  const response = await api.post("/admin/users", userData);
  return response.data;
};

const toggleUser = async (userId) => {
  const response = await api.patch(`/admin/users/${userId}/toggle`);
  return response.data;
};

const restoreUser = async (userId) => {
  const response = await api.patch(`/admin/users/${userId}/restore`);
  return response.data;
};

// Soft delete — the "Delete" action on the Resources list. Moves the user to
// the Archived tab, where they can be restored or permanently deleted.
const archiveUser = async (userId) => {
  const response = await api.patch(`/admin/users/${userId}/archive`);
  return response.data;
};

// Hard delete with the full cascade. The backend rejects this unless the user
// is already archived, so it is only reachable from the Archived tab.
const deleteUser = async (userId) => {
  const response = await api.delete(`/admin/users/${userId}`);
  return response.data;
};

const getProjectsWithAccess = async () => {
  const response = await api.get("/settings/project-access");
  return response.data;
};

// Grants every selected resource access in one request. Unlike the project
// "Add Member" route, this accepts client (viewer) accounts too.
const grantProjectAccess = async (projectId, userIds) => {
  const response = await api.post(
    `/settings/project-access/${projectId}/grant`,
    { userIds },
  );
  return response.data;
};

const updateUserRole = async (userId, userData) => {
  const response = await api.put(`/settings/roles/${userId}`, userData);
  return response.data;
};

const getContacts = async () => {
  const response = await api.get("/settings/contacts");
  return response.data;
};

const updateContact = async (userId, userData) => {
  const response = await api.put(`/settings/contacts/${userId}`, userData);
  return response.data;
};

const settingsService = {
  getUsers,
  getArchivedUsers,
  getUserById,
  inviteUser,
  toggleUser,
  restoreUser,
  archiveUser,
  deleteUser,
  getProjectsWithAccess,
  grantProjectAccess,
  updateUserRole,
  getContacts,
  updateContact,
};

export default settingsService;
